export enum ChartRange {
  Day = '24h',
  Week = '1w',
  Month = '1m',
}

export enum CryptoFiat {
  Crypto = 'crypto',
  Fiat = 'fiat',
}

export type InstrumentPriceT = {
  instrument_id: string;
  ask: number;
  bid: number;
  price_24h_change: number;
  ts: string; // timestamp "2022-06-01 07:43:32"
};

export type InstrumentPriceBarT = {
  instrument_id: string;
  high: number;
  low: number;
  ts: string;
  open: number;
  close: number;
  price_24h_change: number;
};

export type InstrumentTradeFeesT = {
  escrow_fee: string;
  trading_fee: string;
  transaction_fee: string;
  instrument: string;
};

export type InstrumentFeesT = {
  instrument_id: string;
  maker_progressive: number;
  taker_progressive: number;
  maker_flat: number;
  taker_flat: number;
};

export type InstrumentT = {
  name: string;
  instrument_id: string;
  instName: string;
  base_currency_id: string;
  quote_currency_id: string;
  price_decimals: number;
  min_quantity: number;
  max_quantity: number;
  min_quote_quantity: number;
  max_quote_quantity: number;
  price: InstrumentPriceT;
  trading_fees: InstrumentFeesT;
  quote_currency: {
    precision: number;
  };
  base_currency: {
    precision: number;
  };
  price_bars: Array<InstrumentPriceBarT>;
};

export type CurrencyT = {
  precision: number;
  type: CryptoFiat;
  is_active: boolean;
};

export type PriceT = {
  instrument_id: string;
  price: {
    ask: number;
    bid: number;
    ts_iso: string;
    price_24h_change: number;
  };
};

export type ChartRangeOptionT = {
  id: string;
  key: string;
  label: string;
  periodicity: string;
  limit: number;
};

export type FeesT = {
  gas_deposit: string;
  trading_fee: string;
  slippage: string;
};
